import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTrigger } from "@clarkinc/zest-design-system/ui";
import React from "react";
import PlusSubscriptionModalStore, { ModalTypes } from "~/common/PlusSubscriptionModal/PlusSubscriptionModalStore";
const PlusIneligibleModal = () => {
  const isOpen = PlusSubscriptionModalStore.useState(state => state.modalType === ModalTypes.INELIGIBLE);
  const setIsOpen = PlusSubscriptionModalStore.getState().setModalOpen;
  const onOpenChange = (open: boolean) => {
    if (open) {
      setIsOpen(ModalTypes.INELIGIBLE);
    } else {
      setIsOpen(ModalTypes.CLOSED);
    }
  };
  return <Modal open={isOpen} onOpenChange={onOpenChange} aria-label="Plus Ineligible Modal" id="plusIneligibleModal" theme="wss" data-sentry-element="Modal" data-sentry-component="PlusIneligibleModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <img src="//cdnimg.webstaurantstore.com/uploads/design/2017/7/plus-logo.png" alt="WebstaurantPlus" className="max-h-6" />
      </ModalHeader>
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="index.tsx">
        <div className="font-bold text-xl">
          Your current shipping address is not eligible for a Plus Subscription
        </div>
        <div className="pt-3 text-base">
          This program is only available for shipping addresses within the
          contiguous US.
        </div>
      </ModalBody>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <ModalTrigger onClick={() => setIsOpen(ModalTypes.CLOSED)} theme="wss" data-sentry-element="ModalTrigger" data-sentry-source-file="index.tsx">
          Continue Shopping
        </ModalTrigger>
      </ModalFooter>
    </Modal>;
};
export default PlusIneligibleModal;